import enLocale from 'element-ui/lib/locale/lang/en'; // 引入element语言包

const en = {
  Multilingual: {
    siteName: 'South China Sea',
    siteIntroduce: 'infrastructure for ocean & marine data interchange',
    welcome: 'Welcome！',
    logout: 'Logout',
    login: 'Login',
    loginTip: 'It is strictly prohibited to process and transmit state secrets on the non secret platform of the Internet.',
    register: 'Register',
    myOrder: 'My Order',
    FAQ: 'FAQ',
    scrollDown: 'SCROLL',
    latestData: 'Latest Data',
    latestNews: 'Latest News',
    latestEvents: 'Latest Events',
    popularData: 'Popular Data',
    dataDownloading: 'Data downloading',
    dataAssociation: 'Data Association',
    dataAssociationDesc: 'We construct the South China Sea Ocean Data Resource System, linking the integrated data, and linking the connected data so that users can use the data for related analysis.',
    datasets: 'Datasets',
    featuredDatasets: 'Featured Datasets',
    viewMore: 'View More',
    events: 'Events',
    month: 'M',
    news: 'News',
    voyageSurveyNetwork: 'Voyage Survey Network',
    aboutUs: 'About Us',
    subject: 'Subject',
    leaveYourEmailAddress: 'Leave your email address',
    submit: 'SUBMIT',
    anyQuestions: 'Any questions?',
    aboutUsDesc: 'SCSODC has federated open digital repositories to manage, access and share data, information, products and knowledge originating from research cruises, new automatic observing systems. SCSODC is including the important issues of trust which are addressed in data-based research: security, confidentiality, ownership, assured provenance, authenticity, as well as the quality of the data and the metadata.',
    mainPartners: 'Main Partners',
    noData: 'There is no data！',
    downloads: 'Downloads',
    home: 'Home',
    metaData: 'MetaData',
    contactUs: 'My Needs',
    detail: 'Detail',
    edit: 'Edit',
    addToOrder: 'AddToOrder',
    clear: 'Clear',
    addToCart: 'Add To Cart',
    emptyCart: 'Empty Cart',
    dataTarget: 'Data Target',
    seaArea: 'Sea Area',
    subjectSort: 'Subject',
    subjectKeyword: 'Subject Keyword',
    project: 'Project',
    unit: 'Unit',
    deviceName: 'Device Name',
    view: 'View',
    customQuery: 'Custom Query',
    quickSearch: 'Quick Search',
    search: 'search',
    query: 'Query',
    dataComparison: 'Data Comparison',
    fullTextSearch: 'Full Text Search',
    coordinate: 'Coordinate',
    map: 'Map',
    longitude: 'Long',
    latitude: 'Lat',
    keyword: 'Keyword',
    pleaseEnterKeywords: 'Please enter keywords',
    confirm: 'Confirm',
    cancel: 'Cancel',
    dot: 'Dot',
    rectangle: 'Rectangle',
    closeDrawing: 'Close Drawing',
    selectLocation: 'Select Location',
    dataName: 'Data Name',
    dataEntity: 'Data Entity',
    dataUsageSituation: 'Data Usage Situation',
    dataVolume: 'Data Volume',
    listOfDataServices: 'List Of Data Services',
    all: 'ALL',
    orderNumber: 'Order Number',
    orderTime: 'orderTime',
    dataList: 'Data List',
    operation: 'Operation',
    delete: 'Delete',
    userLogin: 'User Login',
    freeSignUp: 'Free SignUp',
    account: 'Account',
    password: 'Password',
    validate: 'Validate',
    rememberPassword: 'Remember Password',
    forgetPassword: 'Forget Password',
    logInWithCstCloudAccount: 'Log In With CstCloud Account',
    userName: 'User Name',
    realName: 'Real Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    workUnit: 'Work Unit',
    setPassword: 'Set Password',
    repeatPassword: 'Repeat Password',
    pleaseEnterYourAccount: 'Please Enter Your Account',
    pleaseEnterYourPassword: 'Please Enter Your Password',
    pleaseEnterYourPasswordAgain: 'Please Enter Your Password Again',
    pleaseEnterYourUserName: 'Please Enter Your UserName',
    pleaseEnterYourRealName: 'Please Enter Your RealName',
    pleaseEnterYourEmail: 'Please Enter Your Email',
    pleaseEnterYourPhoneNumber: 'Please Enter Your PhoneNumber',
    pleaseEnterYourWorkUnit: 'Please Enter Your WorkUnit',
    pleaseEnterYourVerificationCode: 'Please Enter Your Verification Code',
    yourPhoneNumberIsInvalid: 'Your PhoneNumber Is Invalid',
    yourEmailAddressIsInvalid: 'Your EmailAddress Is Invalid',
    clickToUpdate: 'Click To Update',
    retrievePassword: 'Retrieve Password',
    confirmAccount: 'Confirm Account',
    resetPassword: 'Reset Password',
    resetCompleted: 'Reset Completed',
    previous: 'Previous',
    next: 'Next',
    verificationCode: 'Verification Code',
    pleaseEnterYourVerificationCodeFromEmail: 'Please Enter Your Verification Code From Email',
    newPassword: 'New Password',
    pleaseEnterNewPassword: 'Please Enter New Password',
    passwordAgainDifferent: 'Two Inconsistent Passwords!',
    passwordRuleTips: '8-20 Characters, Composed Of Letters And Numbers, Case-Sensitive',
    confirmNewPassword: 'Confirm New Password',
    pleaseEnterNewPasswordAgain: 'Please Enter New Password Again',
    resetCompletedTips: 'Congratulations, Password Reset Is Successful. Please Log In Again!',
    goToLogin: 'Go To Login',
    backToLastPage: 'BACK',
    description: 'Description',
    save: 'Save',
    personalInformation: 'Personal Info',
    basicInformation: 'Basic Info',
    fileList: 'File List',
    frequentlyAskedQuestions: 'FAQ',
    downloadByNeed: 'Please download the corresponding version according to your needs.',
    required: 'Required',
    userAuthentication: 'User Authentication',
    emailAuthentication: 'Email Authentication',
    subjectAuthentication: 'Subject Authentication',
    ordinaryUser: 'Ordinary User',
    ordinaryUserDesc: 'Just register on the platform.',
    authenticatedUser: 'Authenticated User',
    authenticatedUserDesc: 'Complete your phone or email authentication to get more resources',
    subjectUser: 'Subject User',
    subjectUserDesc: 'Complete subject information authentication to get more resources about the subject',
    subjectCertificationRecord: 'Subject Certification Record',
    subjectName: 'Subject Name',
    subjectType: 'Subject Type',
    subjectGrade: 'Subject Grade',
    endTime: 'End Time',
    status: 'Status',
    subjectAuthenticationInformation: 'Subject authentication information',
    subjectAuthenticationInformationDesc: '1. If the application data is used for project research, please fill in the relevant information of the project (project type, name, number, person in charge, etc.), and upload the task or contract front page of the project/project supported by the data, expected results and research objectives, assessment indicators, key participants and the stamped page of the task book through the attachment after scanning.',
    fileSizeTips: '2. The single file size of the uploaded attachment should not exceed 5MB！',
    subjectDetailDesc: '3. Subject certification can only be passed if you are the person in charge of the subject or project！',
    taskBookTitle: 'Task book title',
    taskBookLevel: 'Task Book level',
    projectLevel: 'Project level',
    topicLevel: 'Topic level',
    thematicLevel: 'Thematic level',
    taskTakingUnit: 'Task-taking Unit',
    taskBookType: 'Task book type',
    taskBookNumber: 'Task book number',
    taskForceLeader: 'Task Force Leader',
    executionEndTime: 'Execution end time',
    selectTheDateTime: 'Select the date time',
    subjectProofMaterial: 'Subject Proof Material',
    taskBookHomePage: 'Task Book Home Page',
    pleaseSelect: 'Please select',
    Upload: 'upload',
    expectedResultsAndResearchObjectives: 'Expected results and research objectives',
    assessmentIndex: 'Assessment index',
    listOfParticipants: 'List of participants',
    taskBookSealPage: 'Task Book Seal Page',
    userNameCannotBeEmpty: 'User name cannot be empty',
    realNameCannotBeEmpty: 'Real name cannot be empty',
    emailCannotBeEmpty: 'E-mail cannot be empty',
    mobilePhoneNumberCannotBeEmpty: 'Mobile phone number cannot be empty',
    workUnitsShouldNotBeEmpty: 'Work units should not be empty',
    taskBookNameCannotBeEmpty: 'Task book name cannot be empty',
    taskBookLevelCannotBeEmpty: 'Task Book level cannot be empty',
    taskTakingUnitsShouldNotBeEmpty: 'Task-taking units cannot be empty',
    thePersonInChargeOfTheTaskShouldNotBeEmpty: 'The person in charge of the task should not be empty',
    taskBookNumberCannotBeEmpty: 'Task book number cannot be empty',
    executionEndTimeCannotBeEmpty: 'Execution end time cannot be empty',
    taskBookTypeCannotBeEmpty: 'Task book type cannot be empty',
    assessmentIndicatorsShouldNotBeEmpty: 'Assessment indicators should not be empty',
    theListOfParticipantsCannotBeEmpty: 'The list of participants cannot be empty',
    expectedResultsAndResearchObjectivesShouldNotBeEmpty: 'Expected results and research objectives should not be empty',
    taskBookStampPageCanNotBeEmpty: 'Task Book stamp page can not be empty',
    taskBookHomepageShouldNotBeEmpty: 'Task Book homepage should not be empty',
    site: 'Site',
    operationWebsite: 'Operation Website',
    clickToVisit: 'Click To Visit',
    website1: 'GeoSCS', // 'GeoSCS',
    website2: 'SCSODB', // 'SCSODB',
    website3: 'GDOD', // 'GDOD',
    website4: 'IOBD', // 'IODIS',
    website5: 'GBAD', // 'GBAD',
    website6: 'SCSIS', // 'GBAD',
    websiteDesc1: 'Based on the South China Sea, explore the deep sea and beyond. The Data Sharing Infrastructure of South China Sea and Adjacent Seas (GeoSCS) comprehensively levels up the capabilities of data processing, integration, and services with authoritative. GeoSCS deploys itself at the South China Sea (SCS), the largest marginal sea in the tropical region in China, and integrates the basic environmental observation data and information products of SCS’s adjacent seas. Aims to provide better services on oceanographic studies, environment protection, disasters prevention & reduction, maritime rights and interests maintenance, and knowledge dissemination.',
    websiteDesc2: 'The South China Sea Ocean Database (SCSODB) has been under construction since 2002. It has continuously implemented the “co-construction and sharing” data working mechanism, systematically integrated marine science data from 1985 over the SCS. It has innovated “data life cycle” integrated technology route which runs through the scientific research, and created the “SCS Data Curation Model” to realize the unified aggregation management of data resources and the integration of information knowledge, and established a multi-dimensional and heterogeneous marine data correlation network. It has been integrated into the CSTCloud service environment, which greatly enhances the support surface of the South China Sea marine data open sharing service.',
    websiteDesc3: 'The GuangDong Ocean Data Sharing Infrastructure (GDOD) focuses on the jurisdiction of the Guangdong Province and its adjacent waters. Based on the long-term and rich data accumulation of SCSIO, it established the Guangdong Ocean Data Co-construction and Sharing Mechanism and constructed the Guangdong Marine Science Data Resource Public Service Platform. It has improved data processing and integration capabilities and service capabilities, and provides marine data sharing services, data integration technology support and application training services for all of users across the province.',
    websiteDesc4: 'IOBD constructs the Maritime Silk Road three-dimensional comprehensive data observation network, integrates the Maritime Silk Road multi-source remote sensing information source, establishes the marine environment forecast system for the Maritime Silk Road, integrates the "data + computing power + algorithm" application to build the Maritime Silk Road Big Scientific and Intelligent Data Platform. At present, the platform has initially formed the new mechanism of data work that drives technological innovation and development by the marine big data, promoted data services to run through the entire life cycle of scientific research activities, released multiple sets of numerical model products such as 30 years wind, waves and currents in the Indian Ocean and South China Sea, and released remote sensing data products of marine ecological environment with multiple resolutions in the Indian Ocean and South China Sea. ',
    websiteDesc5: 'The Greater Bay Area is one of the largest port areas and a center of marine industry in the world. To date, marine environment，ecosystems and biological resources in the South China Sea and the Greater Bay Area have experienced substantial impacts from human activities and climate change. The construction of the Greater Bay Area Marine Data Infrastructure (GBAD) will strengthen the current joint effort in advancing/promoting marine science and technology innovation, facilitate the sharing of marine research resources and scientific data, and make continuous and significant contributions to the development of marine science and technology in the Greater Bay Area.',
    websiteDesc6: 'Carry forward the South China Sea spirit, pursue the deep blue ocean dreams',
    viewByVoyage: 'view by voyage',
    customFilter: 'custom filter',
    // 订单详情
    expired: 'Expired',
    days: 'days',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds',
    auditOperation: 'Audit operations',
    auditResults: 'Audit results',
    auditTime: 'Audit time',
    auditReply: 'Audit Reply',
    submitToReview: 'Submit To Review',
    // 数据使用用途
    dataUsage: 'Data Usage',
    listOfData: 'List Of Data',
    userInformation: 'User Info',
    usePurpose: 'Use Purpose',
    selectTheDataUse: 'Select The Data Use',
    dataUse: 'Data Use',
    projectName: 'Project Name',
    addingNewUses: 'Adding New Uses',
    dataApplicationDescription: 'Data Application Description',
    submitTheApplication: 'Submit The Application',
    applicationType: 'Application Type',
    papersTitles: 'Papers/Titles',
    name: 'Name',
    projectNumber: 'Project Number',
    schoolInformation: 'School Info',
    projectLeader: 'Project Leader',
    tutorName: 'Tutor Name',
    personInCharge: 'Person InCharge',
    projectUndertaker: 'Project Undertaker',
    tutorContact: 'Tutor Contact',
    commitmentUnit: 'Commitment Unit',
    graduationTime: 'Graduation Time',
    relatedMaterials: 'Related Materials',

    // 专题案例字段
    relatedResources: 'Related Resources',
    addRelatedResources: 'Add Related Resources',
    classicCase: 'Classic Case',
    addClassicCase: 'Add Classic Case',
    instituteContactLocal: 'Institute Contact Local',
    serviceObject: 'Service Object',
    serviceTime: 'Service Time',
    backgroundAndSignificanceOfServices: 'Background And Significance Of Services',
    serviceContentAndMode: 'Service content and mode',
    organizationalManagement: 'Organizational Management',
    achievements: 'Achievements',

    // 元数据详情字段
    dataCoreDescriptionInformation: 'Data Core Description Information',
    dataTitle: 'Data Title',
    dataIdentification: 'Data Identification',
    subjectKeywords: 'Subject Keywords',
    factorWord: 'Factor Words',
    timeResolution: 'Time Resolution',
    dataTime: 'Data Time',
    spatialLocation: 'Spatial Location',
    spatialScale: 'Spatial Scale',
    spatialResolution: 'Spatial Resolution',
    scale: 'Scale',
    dataGeneration: 'Data Generation',
    dataType: 'Data Type',
    subjectCategory: 'Subject Category',
    dataDescription: 'Data Description',
    dataSourceDescription: 'Data Source Description',
    dataProductionMethod: 'Data Production Method',
    dataProjectionInformation: 'Data Projection Info',
    dataQualityInformation: 'Data Quality Info',
    dataAccessMode: 'Data Access Mode',
    DOINumber: 'DOI Number',
    dataContributor: 'Data Contributor',
    nameOfDataContributor: 'Name Of Data Contributor',
    dataContributorMailbox: 'Data Contributor Mailbox',
    dataContributorUnit: 'Data Contributor Unit',
    dataReferenceAndStatement: 'Data Reference And Statement',
    emailNotificationOfDataBeingUsed: 'Email Notification Of Data Being Used',
    dataResponsibleUnitsAndContacts: 'Data Responsible Units And Contacts',
    nameOfDataResponsibleUnit: 'Name Of Data Responsible Unit',
    addressOfDataResponsibleUnit: 'Address Of Data Responsible Unit',
    postalCodeOfDataResponsibleUnit: 'Postal Code Of Data Responsible Unit',
    nameOfDataContact: 'Name Of Data Contact',
    contactMailbox: 'Contact Mailbox',
    contactPhone: 'Contact Phone',
    associatedDevice: 'Associated Device',
    device: 'Device',
    dataAttachment: 'Data Attachment',
    dataDocument: 'Data Document',
    dataSample: 'Data Sample',
    DataPool: 'Data Pool',
    thumbnail: 'Thumbnail',
    shared: 'Shared',
    sharedType: { 11: 'ONLINE', 13: 'AUTH', 14: 'SUBJECT', 21: 'USER LICENSE' },

    // 首页导航
    bigData: 'Big Data',
    browseData: 'XCharts',
    accessProducts: 'Products',
    downloadSoftware: 'Software',
    bigDataVisualization: 'Big Data Visualization',
    stations: 'Stations',
    geospatialData: 'Geospatial Data',
    thematicSelectedCharacteristicHotspot: 'Characteristic',
    thematicService: 'Thematic Service',
    characteristicService: 'Characteristic Service',
    excellentResources: 'Excellent Resources',
    projectServices: 'Projects',
    integratedForecastService: 'Interchange',
    dataExchangeService: 'Data Asset System',
    dataCatalogService: 'Data Catalog System',
    dataCatalog: 'Data Catalog',
    disciplineGroupSpace: 'Discipline Group Space',
    dirKeeper: 'Directory Keeper',
    laboratory: 'Laboratory',
    boutiqueImages: 'Atlas',

    // 汇交服务
    dataAuditing: 'Data Auditing',
    voyageObservationDataExchange: 'Voyage observation data exchange',
    stationObservationDataExchange: 'Station observation data exchange',
    projectResearchDataExchange: 'Project research data exchange',
    articleLinkedDataExchange: 'Article linked data exchange',
    degreeThesisDataExchange: 'Degree thesis data exchange',
    personalDataProductExchange: 'Personal data product exchange',
    dataPool: 'Data Pool',
    addProject: 'Add Project',
    addMetaData: 'Add Meta Data',
    chooseMetadata: 'Choose Meta data',
    projectIntroduction: 'Project Introduction',
    projectInformation: 'Project Information',
    projectPrincipal: 'Project Principal',
    projectType: 'Project Type',
    executionCycle: 'Execution Cycle',
    executionCycleStartDate: 'Execution Cycle Start Date',
    executionCycleEndDate: 'Execution Cycle End Date',
    backgroundImage: 'Background Image',
    addArticle: 'Add Article',
    revokeReview: 'Revoke review',
    articleName: 'Article Name',
    addPaper: 'Add Paper',
    paperName: 'Paper Name',
    author: 'author',
    degree: 'degree',
    major: 'major',
    studentId: 'Student Id',
    paperTopics: 'paperTopics',
    time: 'time',
    tutor: 'tutor',
    addPersonalDataProduct: 'add Personal Data Product',
    awards: 'Awards',
    content: 'Awards',

    // 南海诸岛
    geography: 'Geography',
    environmentalObservation: 'Environmental observation',
    ecology: 'Ecology',
    geology: 'Geology',
    earthObservation: 'Earth observation',
    atmosphere: 'Atmosphere',
    vegetationGreening: 'Vegetation greening',
    corrosionInvestigation: 'Corrosion investigation',
    energy: 'Energy',
    selectToFilterDataType: 'Select to filter data type',
    standard: 'Standard',
    satellite: 'Satellite',

    // 科考故事
    scientificStory: 'Scientific Story',

    // 查看、喜欢/收藏、转发、分享
    views: 'views',
    likes: 'likes',
    collection: 'collection',
    forward: 'forward',
    shares: 'shares',

    // 专精特新
    synthesizeType: ['Thematic Resources', 'Selected Resources', 'Special Resources', 'New Hot Resources'],

    // 台站
    stationName: 'Station Name',
    buildDate: 'Build Date',
    circleLayer: 'Circle Layer',

    // 科普专栏
    popularScience: 'Popular Science',

    // 浮潜标
    buoy: 'Buoy',
    submarine: 'Submarine',
    buoySubmarine: 'Buoys',

    // 使用情况
    username: 'username',
    dept: 'dept',
    usagePurpose: 'usage purpose',
    usageTime: 'usage time',

    // 商品
    buyNow: 'Buy Now',
    purchased: 'Purchased',
    metaDataCode: 'code',
    code: 'code',
    downloadNum: 'download number',
    visitNum: 'visit number',
    price: 'price',
    balance: 'balance',
    userCenter: 'User Center',
    orderNo: 'Order No',
    transactionTime: 'Transaction Time',
    ownerAccount: 'Owner Account',
    ownerUnit: 'Owner Unit',
    consumerAccount: 'Consumer Account',
    consumerUnit: 'Consumer Unit',
    download: 'download',

    // 知识图谱
    knowledgeGraph: 'Association',

    // 数据中心
    dataCenter: 'Virtual Trading System',
    dataMarket: 'Data Market',
    dataAsset: 'Data Asset',
    dataCommodity: 'Data Commodity',
    transactionRecord: 'Transaction Record',
    transactionNetwork: 'Transaction Network',
    digitalBabe: 'Balance',
    income: 'Income',
    expend: 'Expend',
    myCollection: 'Collection',

    // 数据申请
    dataApply: 'Data Apply',
    myPendingReview: 'My Pending Review',
    pendingReview: 'Pending Review',
    myReviewed: 'My Reviewed',
    myApply: 'My Apply',
    agree: 'Agree',
    reject: 'Reject',
    reviewComment: 'Review Comment',
    orderDetail: 'Order Detail',
    audit: 'Audit',

    category: 'category',
    platformMatrix: 'Platform Matrix',
    pleaseEnterSearchContent: 'please enter search content',

    helpCenter: 'Help Center',
    instructions: 'Instructions',
    introduction: 'Introduction',
    document: 'Document',
    documentDetail: 'Document Detail',
    commonProblem: 'Common Problem',
    southChinaSeaIntroduction: 'South China Sea Introduction',
    developmentHistory: 'Development History',
    websiteFeatures: 'Website Features',
    ipAddress: 'IP Address',
    fileSize: 'File Size',
  },
  ...enLocale,
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js